module.exports = __webpack_public_path__ + "static/img/icon_partner_crrc.bd1b8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_crrc.png
// module id = m0Ka
// module chunks = 1